<!--
 * @Description: 专业设备详情弹窗
-->
<template>
  <div>
    <el-dialog
      :visible="visible"
      :before-close="close"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="专业设备"
      class="performance-detail-modal"
    >
      <el-row>
        <el-col class="detail-title"> 设备详情 </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.teamName" >
          <span class="item-name">所属工队：</span>
          <span class="item-value">{{ detailData.teamName }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" >
          <span class="item-name">设备名称：</span>
          <span class="item-value">{{ detailData.name }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.model" >
          <span class="item-name">设备型号：</span>
          <span class="item-value">{{ detailData.model }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" >
          <span class="item-name">设备数量：</span>
          <span class="item-value">{{detailData.countNum }}台</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.features">
          <span class="item-name">设备功能：</span>
          <span class="item-value">{{detailData.features}}</span>
        </el-col>
         <el-col :span="12" class="detail-item" v-if="detailData.years">
          <span class="item-name">设备年限：</span>
          <span class="item-value">{{ detailData.years }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.status">
          <span class="item-name">资产状态：</span>
           <span v-if="detailData.status === '0'">闲置</span>
           <span v-if="detailData.status === '1'">使用</span>
        </el-col>
        <el-col :span="24" class="detail-item" >
          <span class="item-name">设备简介：</span>
          <span class="item-value">{{ detailData.describe }}</span>
        </el-col>
        <el-col :span="24" class="detail-item">
          <span class="item-name">设备照片：</span>
          <span class="item-value" >
            <template  v-if="detailData.picture">
              <span v-for="(item,index) in detailData.picture.split(',').map(item=>item)" :key="index">
              <el-image
              fit="cover"
              :z-index="9999"
              style="width: 60px; height: 44px;margin-top:5px;margin-right:10px"
              :src="item"
              :preview-src-list="detailData.picture.split(',')"
              :append-to-body="true"
            ></el-image>
              </span>
            </template>
          </span>
        </el-col>
      </el-row>
      <el-row v-if="(detailData.newFiledArr&&detailData.newFiledArr.length) || (detailData.fileList&&detailData.fileList.length)">
        <el-col class="detail-title" style="margin-top: 20px">
          新增字段
        </el-col>
        <el-col :span="24" class="detail-item" v-for="(field,index) in detailData.newFiledArr" :key="index">
          <span class="item-name">{{ field.name }}：</span>
          <span class="item-value">{{ field.content }}</span>
        </el-col>
        <el-col
          :span="24"
          class="detail-item"
          v-if="detailData.fileList&&detailData.fileList.length"
        >
          <span style="" class="item-name">附件：</span>
          <span style="display: flex; flex-wrap: wrap">
            <div
              v-for="(file, index) in detailData.fileList"
              :key="index"
              class="file-item"
            >
              <div class="file-item-container">
                <img
                  :src="fileIcon[file.name.split('.').pop().toLowerCase()]"
                  alt=""
                  class="file-icon"
                />
                <div class="file-info">
                  <div class="file-name">
                    <div class="fore">
                      {{
                        file.name.slice(0, file.name.lastIndexOf("."))
                      }}
                    </div>
                    <div class="back">
                      .{{ file.name.split(".").pop() }}
                    </div>
                  </div>
                  <div class="file-other">
                    <span class="file-size">{{
                      formatFileSize(file.size)
                    }}</span>
                    <span
                      class="file-download"
                      @click="$previewFile(file.fileUrl)"
                      >预览</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </span>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { apiTeamDetail } from "@/api/apiTeamDetail"
import moment from "moment"
import "@/utils/previewFile"

export default {
  name: "PerformanceDetailsModal",
  data() {
    return {
      visible: false,
      detailData: {},
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      }
    }
  },
  components: {},
  methods: {
    /**
     * 打开专业设备详情弹窗
     * @param no 专业设备no
     */
    async open(no) {
      this.visible = true
      const res = await apiTeamDetail.getEquipmentDetail(no)
      if (res.data.code == 200) {
        this.detailData = res.data.data
        if (this.detailData.images) {
          this.detailData.images = this.detailData.images.split(",")
        }
      } else {
        this.$message.error(`系统异常，请稍后再试`)
      }
    },
    // 关闭专业设备弹窗
    close() {
      this.visible = false
      this.detailData = {}
    },
     /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
     formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize / 1024 > 10) {
        return `${(fileSize / 1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    /**
     * 格式化时间
     * @param time 原时间信息
     * @param format 格式，默认YYYY-MM-DD
     */
    formatTime(time, format = "YYYY-MM-DD") {
      return moment(time).format(format)
    }
  }
}
</script>

<style lang="scss" scoped>
.performance-detail-modal {
  /deep/.el-dialog__title {
    line-height: 1;
  }
  /deep/ .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid var(--FCe);
  }
  /deep/.el-dialog__body {
    padding: 30px 20px 20px !important;
    border-top: none !important;
  }
  .detail-title {
    margin-bottom: 10px;
    position: relative;
    padding: 0 0 10px 13px;
    font-size: 18px;
    color: var(--Cfs2);
    border-bottom: 1px dashed #e5e5e5;
    &:before {
      content: "";
      position: absolute;
      top: 2px;
      left: 0;
      width: 3px;
      height: 20px;
      background: var(--Cfs3);
    }
  }
  .detail-item {
    display: flex;
    padding: 10px 0;
    // align-items: center;
    &:last-of-type {
      padding-bottom: 0;
    }
    .item-name {
      flex-shrink: 0;
      color: var(--FC6);
    }
    .item-value {
      color: var(--FC3);
      .item-video {
        position: relative;
        display: inline-block;
        width: 150px;
        height: 100px;
        cursor: pointer;
        > video {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(calc(-50% + 10px), -50%);
          border: solid;
          border-width: 10px 15px;
          border-color: transparent transparent transparent #fff;
        }
      }
    }
    .file-item {
      .file-item-container {
        box-sizing: border-box;
        width: 236px;
        display: flex;
        padding: 10px 20px 10px 10px;
        margin:0px 10px 10px 0px ;
        background-color: #fafafa;
        font-size: 14px;
        border-radius: 4px;
        .file-icon {
          width: 33px;
          height: 40px;
        }
        .file-info {
          flex: 1;
          padding-left: 10px;
          line-height: 1.2;
          .file-name {
            margin-bottom: 10px;
            display: flex;
            color: var(--FC3);
            .fore {
              max-width: 148px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
            .back {
              flex-shrink: 0;
            }
          }
          .file-other {
            display: flex;
            justify-content: space-between;
            .file-size {
              color: var(--FC9);
            }
            .file-download {
              cursor: pointer;
              color: #0286df;
            }
          }
        }
      }
    }
  }
}
</style>


